export default "__VITE_ASSET__1d434c4d__"